import avatar1 from '../assets/img/Avatars/avatar1.png';
import avatar2 from '../assets/img/Avatars/avatar2.png';
import avatar3 from '../assets/img/Avatars/avatar3.png';
import avatar4 from '../assets/img/Avatars/avatar4.png';
import avatar5 from '../assets/img/Avatars/avatar5.png';
import avatar6 from '../assets/img/Avatars/avatar6.png';
import avatar7 from '../assets/img/Avatars/avatar7.png';
import avatar8 from '../assets/img/Avatars/avatar8.png';
import avatar9 from '../assets/img/Avatars/avatar9.png';
import avatar10 from '../assets/img/Avatars/avatar10.png';
import avatar11 from '../assets/img/Avatars/avatar11.png';
import avatar12 from '../assets/img/Avatars/avatar12.png';

     

  export const avatars = [
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
    avatar11,
    avatar12,
  ];







